
export enum MeshCellTextAlign
{
    Left = 'Left',
    Center = 'Center',
    Right = 'Right',
}

export enum MeshCellVertAlign
{
    Top = 'Top',
    Center = 'Center',
    Bottom = 'Bottom',
}

export enum MeshCellTextWrapping
{
    Default = 'Default',
    Wrap = 'Wrap',
    Clip = 'Clip',
}
